import { BasicModal } from '@DesignSystem/modals';
import React from 'react';
import { useDeleteServiceAccountApiKey } from '@account-settings/api';
import { DeleteApiKeyPayload } from '@/features/account-settings/api/service-account/useDeleteServiceAccountApiKey';
import styles from './APIKeysModal.module.scss';

type DeleteAPIKeyModalProps = {
  isOpen: boolean;
  onClose: () => void;
} & DeleteApiKeyPayload;

const DeleteAPIKeyModal: React.FC<DeleteAPIKeyModalProps> = ({
  onClose,
  isOpen,
  ...payload
}) => {
  const { mutate: deleteKey } = useDeleteServiceAccountApiKey();

  const handleDeleteKey = () => {
    deleteKey(payload, {
      onSuccess: onClose
    });
  };

  return (
    <BasicModal
      open={isOpen}
      title="Are You Sure?"
      primaryButtonText="Delete"
      secondaryButtonText="Cancel"
      additionalClasses={{ paper: styles.deleteModal }}
      onPrimaryButtonClick={handleDeleteKey}
      onSecondaryButtonClick={onClose}
      onClose={onClose}
      content={`The API key will be permanently deleted from "${payload.serviceAccountName}"
          service account and cannot be recovered.`}
    />
  );
};

export default DeleteAPIKeyModal;
